<template>
    <page-table />
  </template>
  <script>
  import PageTable from './components/table'
  export default {
    name: 'financial-finSet-budget',
    components: {
      PageTable,
    },
  }
  </script>